export default "__VITE_ASSET__56216bf9__"